module.exports = __webpack_public_path__ + "img/image1.4a531113.png";